import { createFileRoute } from "@tanstack/react-router";
import CountyPage from "@/pages/CountyPage";
import { buildHead } from "@/lib/seo";
import { areas } from "@/data/areas";

export const Route = createFileRoute("/areas/broward-county")({
  loader: async () => ({
    area:
      areas.find((a) => a.slug === "broward-county" && a.type === "county") ??
      null,
  }),
  head: ({ loaderData }) => {
    const area = loaderData?.area;
    if (!area) {
      return buildHead({
        title: "County Not Found | Precision Pavers & Pool Design",
        description:
          "Precision Pavers & Pool Design — your local outdoor living experts.",
        path: "/areas",
      });
    }
    const path = `/areas/${area.slug}`;
    return buildHead({
      title: area.heroTitle,
      description:
        area.seoDescription ||
        `Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in ${area.name}. Family-owned. Free estimates.`,
      path,
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Areas",
            item: "https://precisionpaverspools.com/areas",
          },
          {
            "@type": "ListItem",
            position: 3,
            name: area.name,
            item: `https://precisionpaverspools.com/areas/${area.slug}`,
          },
        ],
      },
    });
  },
  component: () => <CountyPage presetSlug="broward-county" />,
});
